export default __webpack_public_path__ + "static/media/touchapp-schaltschraenke-grafik2-en-2000x2000px.6bfd81f9.png";